import { jsonFetch } from "../../../lib/helpers";
import { RoomIntegrationData } from "../../../models/room";
import { getRoomsWithIntegrationsUrl } from "./api-url.constants";
import { mapRoomsWithIntegrations } from "./mappers";

// DTO para la respuesta del backend
interface RoomIntegrationDataDTO {
  _id: string;
  name: string;
  address: string;
  address2?: string;
  guestyLinkedRoom?: {
    _id?: string;
    nickname?: string;
    title?: string;
  };
  avantioLinkedRoom?: {
    id?: string;
    name?: string;
  };
  krossLinkedRoom?: {
    idProperty?: string;
    idRoom?: string;
    idRoomType?: string;
    number?: string;
    nameRoomType?: string;
    qtGuests?: string;
  };
  hostifyLinkedListing?: {
    id?: string;
    nickname?: string;
    address?: string;
    city?: string;
  };
  rentalreadyLinkedRental?: {
    rentalId?: string;
    name?: string;
    city?: string;
  };
  icneaLinkedProperty?: {
    lodgingId?: number;
    name?: string;
    address?: string;
    city?: string;
    country?: string;
  };
}

interface GetRoomsWithIntegrationsResponse {
  data: {
    rooms: RoomIntegrationDataDTO[];
  };
}

export const getRoomsWithIntegrations = async (
  ownerId?: string
): Promise<RoomIntegrationData[]> => {
  const response = await jsonFetch<GetRoomsWithIntegrationsResponse>(
    getRoomsWithIntegrationsUrl(ownerId)
  );
  return response.data.rooms.map(mapRoomsWithIntegrations);
};
